import { handleActions } from 'redux-actions';
import { State, stateUpdate, stateClear } from './action';

const initialState: State = {
  isLoading: false
};

export default handleActions(
  {
    [String(stateUpdate)]: (state, { payload }) => {
      return {
        ...state,
        ...payload,
      };
    },
    [String(stateClear)]: () => {
      return initialState;
    },
  },
  initialState,
);
